export const DIVIDER_BLOCK_TYPE = 'divider';
export const BUTTON_BLOCK_TYPE = 'button';
export const ATTACHMENT_BLOCK_TYPE = 'attachment';
export const EVENT_CALENDAR_BLOCK_TYPE = 'eventcalendar';
export const LOCATION_MAP_BLOCK_TYPE = 'location';
export const CANVAS_BLOCKS = 'canvas-blocks';
export const COLUMNS_BLOCK_TYPE = 'columns';
export const IMAGE_BLOCK_TYPE = 'upload';
/**@deprecated use richtext instead */
export const SWIFT_PREDICT_BLOCK_TYPE = 'swiftpredict';
export const RICH_TEXT_BLOCK_TYPE = 'richtext';
export const VIDEO_BLOCK_TYPE = 'video';
